<div class="pnl-settings">
  <header>
    <h1>Configurações</h1>
  </header>
  <section>
    <div>
      <a [routerLink]="['design']">
        <figure>
          <i class="ic ic-set-design"></i>
        </figure>
        <span>
          <strong>Design da loja</strong>
          <small
            >Personalize o visual da loja virtual com cores, banners, logotipo e
            páginas com informações</small
          >
        </span>
      </a>

      <a [routerLink]="['metodos-de-pagamentos']">
        <figure>
          <i class="ic ic-set-payments"></i>
        </figure>
        <span>
          <strong>Formas de pagamento</strong>
          <small
            >Habilite e gerencie os meios de pagamento que estarão disponíveis
            para os consumidores pagarem
          </small>
        </span>
      </a>
    </div>

    <div>
      <a [routerLink]="['drive-thru']">
        <figure>
          <i class="ic ic-set-drive"></i>
        </figure>
        <span>
          <strong>Drive thru</strong>
          <small
            >Configure a sua loja para oferecer o serviço de drive thru</small
          >
        </span>
      </a>
      <a [routerLink]="['frete-entrega']">
        <figure>
          <i class="ic ic-set-delivery"></i>
        </figure>
        <span>
          <strong>Frete e entrega</strong>
          <small
            >Defina as regiões para atendimento delivery, preço por distância e
            horários de entrega</small
          >
        </span>
      </a>
    </div>

    <div *ngIf="isMatriz">
      <a [routerLink]="['parametros']">
        <figure>
          <fa-icon [icon]="faSlidersH"></fa-icon>
        </figure>
        <span>
          <strong>Parâmetros</strong>
          <small>Habilite e configure os parâmetros do site</small>
        </span>
      </a>

      <a [routerLink]="['departamentos']">
        <figure>
          <fa-icon [icon]="faStream"></fa-icon>
        </figure>
        <span>
          <strong>Departamentos</strong>
          <small
            >Adicione e gerencie os departamentos da sua loja virtual</small
          >
        </span>
      </a>
    </div>

    <div>
      <a [routerLink]="['colaboradores']">
        <figure>
          <i class="ic ic-set-users"></i>
        </figure>
        <span>
          <strong>Colaboradores</strong>
          <small
            >Adicione e gerencie pessoas na sua equipe operacional para que
            possam acessar esta plataforma</small
          >
        </span>
      </a>

      <a [routerLink]="['importacao-de-dados']">
        <figure>
          <i class="ic ic-set-import"></i>
        </figure>
        <span>
          <strong>Importação de dados</strong>
          <small
            >Transfira e sincronize automaticamente os preços de uma planilha
            Excel</small
          >
        </span>
      </a>

      <!-- <a class="dnone" class="vhidden"></a> -->
    </div>
    <div>
      <a class="dnone disabled">
        <figure>
          <i class="ic ic-set-nfe"></i>
        </figure>
        <span>
          <strong>NF-e</strong>
          <small
            >Habilite o sistema que irá gerar uma nota fiscal eletrônica do
            pedido e enviada ao consumidor</small
          >
        </span>
      </a>

      <a class="dnone disabled">
        <figure>
          <i class="ic ic-set-import"></i>
        </figure>
        <span>
          <strong>Importação de dados</strong>
          <small
            >Transfira e sincronize automaticamente os preços de uma planilha
            Excel ou de um arquivo XML</small
          >
        </span>
      </a>
    </div>
  </section>
</div>
